import requestService from '../../services/request';
import { NEWS_VIDEOS } from '../../utils/constants';

export default {
  state: {
    news: [],
    lastEnterpriseParams: null,
    error: null,
    loading: false
  },
  getters: {
    [NEWS_VIDEOS.GET_VIDEOS]: state => state.news,
    [NEWS_VIDEOS.HAS_VIDEOS]: state => state.news.length > 0
  },
  mutations: {
    [NEWS_VIDEOS.SET_VIDEOS]: (state, payload) => {
      state.news = payload;
    }
  },
  actions: {
    [NEWS_VIDEOS.FETCH_VIDEOS]: async (
      { state, commit },
      { enterpriseParams }
    ) => {
      try {
        if (state.loading) return;
        const enterpriseParamsString = JSON.stringify(enterpriseParams);
        if (
          state.lastEnterpriseParams !== enterpriseParamsString ||
          !!state.error
        ) {
          state.loading = true;
          state.lastEnterpriseParams = enterpriseParamsString;
          const url = `${process.env.GET_BY_ENTERPRISE}/newsVideo`;
          const result = await requestService(url, 'GET', {
            params: {
              ...enterpriseParams,
              desiredFields: {
                attachment: 1,
                createdAt: 1,
                lastModified: 1,
                title: 1,
                description: 1
              }
            },
            localErrorHandling: true
          });

          commit(NEWS_VIDEOS.SET_VIDEOS, result);
        }
      } catch (err) {
        console.error(err);
        state.error = err;
      } finally {
        state.loading = false;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/newsVideo.js